import { useState } from 'react';
import { useSelector } from 'react-redux';
import CustomerCardComponentSp from '../../../../components/common/customer/customerCard/sp/customerCardSp';
import customerGetCardsApi from '../../../../apis/customer/customerGetCardsApi';
import customerPostCardsApi from '../../../../apis/customer/customerPostCardsApi';
import customerGetCardImageApi from '../../../../apis/customer/customerGetCardImageApi';
import CustomerCardComponent from '../../../../components/common/customer/customerCard/customerCardComponent';

function CustomerCardContainer(props) {
  const { customerId, refreshing, open, onClose } = props;

  const isSp = useSelector((state) => state.deviceTypeSlice.isSp);

  // 顧客カードのリスト
  const [cards, setCards] = useState([]);

  const getCustomerCards = async () => {
    await customerGetCardsApi(customerId)
      .then((res) => setCards(res.data))
      .catch((err) => console.error(err));
  };

  const postCustomerCards = async (params) => {
    await customerPostCardsApi(params)
      .catch((err) => console.error(err));
  };

  const getCustomerCardImage = async (cId) => {
    const res = await customerGetCardImageApi(cId)
      .catch((err) => console.error(err));
    return res?.data ?? null;
  };

  return isSp ? (
    <CustomerCardComponentSp
      refreshing={refreshing}
      cards={cards}
      getCustomerCards={getCustomerCards}
      postCustomerCards={postCustomerCards}
      getCustomerCardImage={getCustomerCardImage}
      customerId={customerId}
    />
  ) : (
    <CustomerCardComponent
      cards={cards}
      open={open}
      onClose={onClose}
      getCustomerCards={getCustomerCards}
      postCustomerCards={postCustomerCards}
      getCustomerCardImage={getCustomerCardImage}
      customerId={customerId}
    />
  );
}

export default CustomerCardContainer;
